import * as actionTypes from "./invoiceType";

const INITIAL_STATE = {
  invoiceList: [],
  invoiceCount: [],
};

const InvoiceReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.SETINVOICELIST:
      return {
        ...state,
        invoiceList: action.payload,
      };
    case actionTypes.SETINVOICECOUNT:
      return {
        ...state,
        invoiceCount: action.payload,
      };
    default:
      return state;
  }
};

export default InvoiceReducer;
